module.exports = __webpack_public_path__ + "images/8135e1496d67f0d4129e5a4aa3134d7a.png";